import axios from 'axios';
import { SERVER_URL } from 'Constants';
import useAsync from 'Hooks/useAsync';
import React from 'react';
import { CreditReportProductDetail } from '../CreditReportSettings/CreditReportProductList';
import { CreditReportSetting } from '../CreditReportSettings/CreditReportSetting';

type Props = {
	businessEntityId: string;
}

export const BusinessEntityCreditReportsSection: React.FunctionComponent<Props> = ({ businessEntityId }) => {
	const getCreditReports = useAsync(async () => {
		const response = await axios.get<CreditReportProductDetail[]>(
			`${SERVER_URL}/api/credit-report/list-business-entity-products/${businessEntityId}`);
		const data = response.data;
		return data;
	}, [businessEntityId]);

	if (getCreditReports.type === 'loading') {
		return <p>Loading...</p>
	}

	if (getCreditReports.error) {
		return <p>Error loading credit reports</p>
	}

	if (getCreditReports.data) {
		return <CreditReportSetting creditReportList={getCreditReports.data}/>
	}

	return null;
}